import React from 'react';

import '../../../../styles/tooltip-layout.scss';

const setupTooltipLayout = (ToolTip) => {
  class MapToolTip extends React.Component {
    render() {
      // eslint-disable-next-line react/prop-types
      const {className = ''} = this.props;

      return (
        <section className={`MapToolTip ${className}`}>
          <ToolTip {...this.props} />
          <div className="MapToolTip__Arrow" />
        </section>
      );
    }
  }

  return MapToolTip;
};

export default setupTooltipLayout;
